import { useCallback } from 'react';

import analyticsProvider from 'state/analytics';
import { useLDContext } from 'state/launchdarkly';

import { UserDetails } from './types';

export const useThirdPartyAuthentication = () => {
  const { login: launchDarklyLogin, logout: launchDarklyLogout } = useLDContext();

  const logUserInToThirdPartyServices = useCallback(
    (currentUser: UserDetails) => {
      launchDarklyLogin(currentUser);

      analyticsProvider.setCustomerIdentity({
        customerId: currentUser.thLegacyCognitoId
          ? `us-east-1:${currentUser.thLegacyCognitoId}`
          : currentUser.cognitoId,
        cognitoId: currentUser.cognitoId,
        userAttributes: currentUser.details,
      });
    },
    [launchDarklyLogin]
  );

  const logUserOutOfThirdPartyServices = useCallback(() => {
    launchDarklyLogout();
    analyticsProvider.logOutCustomer();
  }, [launchDarklyLogout]);

  return { logUserInToThirdPartyServices, logUserOutOfThirdPartyServices };
};
